// extracted by mini-css-extract-plugin
export var header = "_sc-1";
export var maskBottom = "_sc-6";
export var maskMiddle = "_sc-7";
export var maskTop = "_sc-5";
export var root = "_sc-0";
export var scrollDownButton = "_sc-3";
export var scrollDownButtonHidden = "_sc-4";
export var viewport = "_sc-2";